<template>
  <div class="list-component">
    <h1>{{ $t('W2P_MY_ORDERS') }}</h1>
    <TableComponent />
  </div>
</template>

<script>
import TableComponent from '@/components/my-orders/TableComponent'

export default {
  components: {
    TableComponent
  }
}
</script>

<style lang="scss" scoped>
.list-component {
  h1 {
    color: $black;
  }
}
</style>
